import { Box, Stack } from '@mui/material';
import { Outlet } from 'react-router';

import AppBar from '@/shared/components/AppBar';
import Breadcrumbs from '@/shared/components/Breadcrumbs/index';
import type { NavItem } from '@/shared/types';

interface PortalShellProps {
  navItems?: NavItem[];
}

const PortalShell = ({ navItems }: PortalShellProps) => (
  <Stack sx={{ height: '100%' }}>
    <AppBar navItems={navItems} />
    <Breadcrumbs />
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'auto' }}>
      <Outlet />
    </Box>
  </Stack>
);

export default PortalShell;
